A job category with information of the suggested choice.
